import api from "services/api";

/* eslint-disable no-console */
export const USER_KEY = "@authenticator/user";
export const TOKEN_KEY = "@authenticator/token";
export const USER_MENU = "@authenticator/menu";
export const LOGO_KEY = "@authenticator/logo";
export const BACKGROUND_KEY = "@authenticator/background";
export const USER_EDIT_KEY = "@edit/user";
export const ATTACHMENT_KEY = "@contract/attachment";
export const PAGE_KEY = "@page/title";
export const ERROR_MESSAGE = "@error/message";
// export const PERMISSION_KEY = "@authenticator/permission";

export const isAuthenticated = () => {
  const localToken = localStorage.getItem(TOKEN_KEY);
  const sessionToken = sessionStorage.getItem(TOKEN_KEY);

  if (!localToken && !sessionToken) {
    return false;
  } else {
    return true;
  }

  // return !token;
  // localStorage.getItem(TOKEN_KEY) !== null
};

export const getUser = () => {
  const localUser = JSON.parse(localStorage.getItem(USER_KEY));
  const sessionUser = JSON.parse(sessionStorage.getItem(USER_KEY));

  if (localUser) {
    return localUser;
  } else {
    return sessionUser;
  }
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const login = async token => {
  //Sistemas antigos
  // sessionStorage.setItem(TOKEN_KEY, token);
  //Sistemas novos

  localStorage.setItem(TOKEN_KEY, token);
};

export const logout = async () => {
  //Sistemas antigos
  sessionStorage.removeItem(USER_MENU);
  sessionStorage.removeItem(USER_KEY);//
  sessionStorage.removeItem(TOKEN_KEY);
  //sessionStorage.removeItem(PERMISSION_KEY);

  //Sistemas novos
  localStorage.removeItem(USER_MENU);
  localStorage.removeItem(USER_KEY);//
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(LOGO_KEY);
  //localStorage.removeItem(PERMISSION_KEY);

   try {
     const localUser = JSON.parse(localStorage.getItem(USER_KEY));
     if (localUser !== null) {
      const response = await api().post(
        `Usuario/Logout?intCodigo=${localUser.codigo}&strEmail=${localUser.email}`,
        {    }
      );       
     }

     //await api().post("Usuario/Logout");
   } catch (err) {
     console.log(err);
   }
};
